<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <MenuLateral/>
                <main role="main" class="col-md-8 ml-sm-auto col-lg-9 px-4 mt-3 mb-3">
                    <router-view></router-view>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
    import MenuLateral from './MenuLateral'
    export default {
        name: 'Corpo',
        components: {
            MenuLateral
        }
    }
</script>

<style scoped>
    
    p {
        color: #fff;
    }

    i {
        font-size: 50px;
    }

    a {
        padding: 12px 5px;
    }

    a:hover {
        background-color: #18a689;
        color: #fff;
        border: none;
    }

    ul {
        margin-top: 20px;
    }

    li .active {
        background-color: #18a689;
    }
    
    main{
        margin-left: 5px!important;
        margin-top: -34px!important;
    }
</style>
